import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import '../../styles/Admin.css';

function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };
  return (
    <div className="admin-layout admin-root">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-logo">
            <img
              src={`${process.env.PUBLIC_URL || ''}/logo-tmstudio.png`}
              alt="TM Studio"
              onError={(e) => {
                e.target.style.display = 'none';
                const fallback = e.target.nextElementSibling;
                if (fallback) fallback.style.display = 'inline-block';
              }}
            />
            <span className="admin-sidebar-logo-fallback" style={{ display: 'none', fontWeight: 700, color: 'var(--admin-primary)' }}>TM</span>
            <div>
              <h1 className="admin-sidebar-brand">
                <span>TM</span> <span>STUDIO</span>
              </h1>
              <p className="admin-sidebar-tagline">Elite Modeling Agency</p>
            </div>
          </div>
        </div>
        <nav className="admin-nav">
          {/* Dashboard oculto hasta implementación posterior */}
          <NavLink
            to="/admin/home"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="material-symbols-outlined">home</span>
            <span>Home</span>
          </NavLink>
          <NavLink
            to="/admin/registros"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="material-symbols-outlined">person_add</span>
            <span>Registros</span>
          </NavLink>
          <NavLink
            to="/admin/satelite"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="material-symbols-outlined">travel_explore</span>
            <span>SATELITE</span>
          </NavLink>
          <NavLink
            to="/admin/galeria"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="material-symbols-outlined">photo_library</span>
            <span>Galería</span>
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-nav-link"
            onClick={() => navigate('/')}
            style={{ width: '100%', justifyContent: 'center', background: 'transparent', border: 'none', cursor: 'pointer', color: 'inherit', font: 'inherit', marginBottom: '0.5rem' }}
            aria-label="Volver a la página principal"
          >
            <span className="material-symbols-outlined">public</span>
            <span>Página principal</span>
          </button>
          <div className="admin-user-card">
            <div className="admin-user-avatar">A</div>
            <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
              <span className="admin-user-name">TMStudioADMIN</span>
              <span className="admin-user-role">Master Control</span>
            </div>
          </div>
          <button type="button" className="admin-nav-link" onClick={handleLogout} style={{ marginTop: '0.5rem', width: '100%', justifyContent: 'center', background: 'transparent', border: 'none', cursor: 'pointer', color: 'inherit', font: 'inherit' }}>
            <span className="material-symbols-outlined">logout</span>
            <span>Cerrar sesión</span>
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
